/* AD Perfumes — shared storefront behaviour.
   Add to Bag uses Shopify's AJAX Cart API (/cart/add.js). Every form also
   works without JavaScript because it is a normal Shopify product form. */
(function () {
  'use strict';

  var ADP = (window.ADP = window.ADP || {});
  var routes = ADP.routes || {};
  var strings = ADP.strings || {};
  var settings = ADP.settings || {};

  /* ---------- Small helpers ---------- */
  ADP.fetchJSON = function (url, options) {
    var opts = Object.assign({ headers: {} }, options || {});
    opts.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers);
    return fetch(url, opts).then(function (res) {
      return res
        .json()
        .catch(function () { return {}; })
        .then(function (data) {
          if (!res.ok || (data && data.status && data.status >= 400)) {
            var err = new Error((data && (data.description || data.message)) || strings.cartError || 'Error');
            err.status = res.status;
            throw err;
          }
          return data;
        });
    });
  };

  ADP.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  /* ---------- Cart count ---------- */
  ADP.setCartCount = function (count) {
    var n = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  };

  ADP.refreshCartCount = function () {
    return ADP.fetchJSON(routes.cart + '.js')
      .then(function (cart) {
        ADP.setCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  };

  /* ---------- Toast ---------- */
  var toastTimer;
  ADP.toast = function (message, opts) {
    var options = opts || {};
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-message]').textContent = message;
    toast.querySelector('[data-toast-link]').hidden = !options.showLink;
    toast.classList.toggle('is-error', !!options.error);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, options.error ? 7000 : 5000);
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) {
      var toast = document.querySelector('[data-toast]');
      if (toast) toast.hidden = true;
    }
  });

  function setFormMessage(form, message, type) {
    var el = form.querySelector('[data-form-message]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
  }
  ADP.setFormMessage = setFormMessage;

  /* ---------- Add to Bag (product page + quick add) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (!window.fetch || !window.FormData) return; // native submit fallback

    e.preventDefault();
    var submitter = e.submitter || form.querySelector('[type="submit"]:focus') || form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (submitter && submitter.name === 'id') formData.set('id', submitter.value);
    formData.delete('add');

    if (!formData.get('id')) {
      setFormMessage(form, strings.unavailable, 'error');
      return;
    }
    if (form.getAttribute('aria-busy') === 'true') return;

    form.setAttribute('aria-busy', 'true');
    if (submitter) submitter.classList.add('is-loading');
    setFormMessage(form, '', null);

    ADP.fetchJSON(routes.cartAdd + '.js', { method: 'POST', body: formData })
      .then(function () {
        if (settings.afterAdd === 'redirect') {
          window.location.href = routes.cart;
          return;
        }
        setFormMessage(form, strings.added, 'success');
        ADP.toast(strings.added, { showLink: true });
        document.dispatchEvent(new CustomEvent('adp:cart-updated'));
        return ADP.refreshCartCount();
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : strings.addError;
        setFormMessage(form, msg, 'error');
        ADP.toast(msg, { error: true });
      })
      .finally(function () {
        form.removeAttribute('aria-busy');
        if (submitter) submitter.classList.remove('is-loading');
      });
  });

  /* ---------- Quantity +/- (product page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10);
    var max = parseInt(input.max, 10);
    var value = parseInt(input.value, 10) || 0;
    value += btn.hasAttribute('data-quantity-plus') ? step : -step;
    if (!isNaN(min) && value < min) value = min;
    if (!isNaN(max) && value > max) value = max;
    if (value < 1) value = 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Header: measurements, menus, search ---------- */
  var header = document.querySelector('[data-header]');
  function measureHeader() {
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-height', Math.round(rect.height) + 'px');
    document.documentElement.style.setProperty('--drawer-top', Math.max(0, Math.round(rect.bottom)) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', ADP.debounce(measureHeader, 150));
  window.addEventListener('scroll', ADP.debounce(measureHeader, 50), { passive: true });

  function closeDetails(except) {
    document.querySelectorAll('[data-nav-dropdown][open], [data-header-search][open], [data-menu-drawer][open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement)) return;
    if (d.matches('[data-nav-dropdown], [data-header-search], [data-menu-drawer]') && d.open) {
      closeDetails(d);
      measureHeader();
    }
    if (d.matches('[data-menu-drawer]')) {
      document.body.classList.toggle('scroll-locked', d.open);
    }
    if (d.matches('[data-header-search]') && d.open) {
      var input = d.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-dropdown], [data-header-search], [data-menu-drawer]')) {
      document.querySelectorAll('[data-nav-dropdown][open], [data-header-search][open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-nav-dropdown][open], [data-header-search][open], [data-menu-drawer][open]');
    if (open) {
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  /* Theme Editor: re-measure when sections change */
  document.addEventListener('shopify:section:load', measureHeader);
})();
